const CONSTANTS = {
    ENDPOINT_SERVICE: {
        API: 1
    },
    ITEM_PER_PAGE: 10,
    AUDIT_ITEM_PER_PAGE: 20,
    LOADING_ICON: '/img/loader-green.gif',
    USER_FUNCTIONS: {
        ANALYZE: 'analyze',
        SYSTEM: 'system',
        USER: 'user',
        NEWS: 'news',
        DATA_LAYER: 'data-layer',
        DATABASE: 'database'
    },
    COMMON_NAV: [
        {
            url: '/dashboard',
            vi: 'Trang chủ',
            isDefault: true
        },
        {
            url: '/general-info',
            vi: 'Thông tin chung'
        },
        {
            url: '/tool',
            vi: 'Công cụ kỹ thuật'
        },
        {
            url: '/news',
            vi: 'Tin tức'
        },
        {
            url: '/feedback',
            vi: 'Liên hệ'
        }
    ],
    NEWS_STATUS: [
        { text: 'NHÁP', value: 'DRAFT' },
        { text: 'PHÁT HÀNH', value: 'PUBLISH' }
    ],
    LAYER_STATUS: [
        { text: 'BẬT', value: true },
        { text: 'TẮT', value: false }
    ],
    LAYER_SYMBOL: [
        { icon: 'tint', color: 'text-primary' },
        { icon: 'shield', color: 'text-success' },
        { icon: 'globe', color: 'text-success' },
        { icon: 'area-chart', color: 'text-info' },
        { icon: 'balance-scale', color: 'text-secondary' },
        { icon: 'bolt', color: 'text-warning' },
        { icon: 'file-code-o', color: 'text-dark' },
        { icon: 'video-camera', color: 'text-danger' }
    ],
    NEWS_TYPE: [
        { text: 'TIN THƯỜNG', value: 'NORMAL' },
        { text: 'TIN CẢNH BÁO', value: 'WARNING' }
    ],
    GEOJSON_RADIO_TYPE: [
        { text: 'TỆP LŨ', value: 'CURRENT_HIGH' },
        { text: 'TỆP MƯA', value: 'CURRENT_RAIN' },
        { text: 'TỆP DỰ BÁO MƯA', value: 'FORECAST_RAIN' },
        { text: 'TỆP KỊCH BẢN LỤT', value: 'SCRIPT_FLOOD' },
        { text: 'TỆP KHÁC', value: 'OTHER' },
        { text: 'TỆP ẢNH', value: 'png' }
    ],
    GEOJSON_TYPE: {
        CURRENT_THUNDER: 'CURRENT_HIGH',
        CURRENT_RAIN: 'CURRENT_RAIN',
        FORECAST_THUNDER: 'FORECAST_HIGH',
        FORECAST_RAIN: 'FORECAST_RAIN',
        OTHER: 'OTHER',
        REAL_RAIN: 'REAL_RAIN',
        REAL_WATER: 'REAL_WATER',
        FOLDER: 'FOLDER',
        SCRIPT_FLOOD: 'SCRIPT_FLOOD',
        CLASS_INUNDATION: 'CLASS_INUNDATION',
        PNG: 'png',
        XLSX: 'xlsx'
    },
    BASE_MAP_OPTIONS: [
        {
            key: 'region',
            label: 'Bản đồ hành chính',
            url: 'https://maps.vnpost.vn/api/tm/{z}/{x}/{y}@2x.png?apikey=674052d5aeb7658157d37306d8fc0bb42e7b69cff5e37440',
        },
        {
            key: 'google-road',
            label: 'Google Map đường phố',
            url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        },
        {
            key: 'google-sat',
            label: 'Google Map vệ tinh',
            url: 'https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        },
        {
            key: 'google-hybrid',
            label: 'Google Map vệ tinh kết hợp',
            url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        },
        {
            key: 'google-terrain',
            label: 'Google Map địa hình',
            url: 'https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
        }
    ],
    RAIN_LEGEND_INFO: [
        {
            value: '0',
            color: 'B3DCFD'
        },
        {
            value: '> 0-5',
            color: '42a5f5'
        },
        {
            value: '5-15',
            color: '1976d2'
        },
        {
            value: '15-30',
            color: 'f57c00'
        },
        {
            value: '30+',
            color: 'e65100'
        }
    ],
    WATER_LEGEND_INFO: [
        {
            value: 'Thấp',
            color: 'B3DCFD'
        },
        {
            value: 'Cấp I',
            color: '42a5f5'
        },
        {
            value: 'Cấp II',
            color: 'ffb300'
        },
        {
            value: 'Cấp III',
            color: 'e65100'
        }
    ],
    THUNDER_LEGEND_INFO: [
        {
            value: '0',
            color: 'D2D5EB'
        },
        {
            value: '> 0-0.5',
            color: 'c5cae9'
        },
        {
            value: '0.5-1',
            color: '9fa8da'
        },
        {
            value: '1-1.5',
            color: '7986cb'
        },
        {
            value: '1.5-2',
            color: '5c6bc0'
        },
        {
            value: '2–2.5',
            color: '3f51b5'
        },
        {
            value: '2.5–3',
            color: '3949ab'
        },
        {
            value: '3–3.5',
            color: '303f9f'
        },
        {
            value: '3.5–4',
            color: '283593'
        },
        {
            value: '4+',
            color: '1a237e'
        }
    ]
};
export default CONSTANTS;
